import { render, staticRenderFns } from "./TareaUsuarioComponent.vue?vue&type=template&id=2943a1c4&"
import script from "./TareaUsuarioComponent.vue?vue&type=script&lang=js&"
export * from "./TareaUsuarioComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports